"use client";

import { type MouseEventHandler, useState } from "react";

import { useRouter } from "@/shared.i18n/navigation";
import { Button } from "@/shared-web.ui/ui.button";
import { buildUrl } from "@/shared-web.ui/util.url";
import { buyNow } from "@/stf.data/request.checkout";
import { useVariantState } from "@/stf.m.product/feat.product-detail";

import { type ServerDataOutput } from "../data.subscription-data";

export type Translation = {
  label: string;
};

interface BuyNowDisplayProps {
  disabled?: boolean;
  onClick?: MouseEventHandler<HTMLButtonElement>;
  t: Translation;
}
export const BuyNowDisplay = (props: BuyNowDisplayProps) => {
  const {
    onClick,
    disabled,
    t: {
      label,
    },
  } = props;

  return (
    <Button
      size="3"
      className="shadow-3"
      type="button"
      onClick={onClick}
      disabled={disabled}
    >
      {label}
    </Button>
  );
};

interface BuyNowButtonWithParamsProps {
  data: ServerDataOutput;
  t: Translation;
}
export const BuyNowButtonWithParams = (props: BuyNowButtonWithParamsProps) => {
  const { data, t } = props;
  const {
    subscriptionData: {
      productId,
    },
  } = data;

  const { opts } = useVariantState();
  const { push } = useRouter();

  const [loading, setLoading] = useState(false);

  const handleBuyNow = async () => {
    if (opts === null) {
      return;
    }

    setLoading(true);

    const selectedItems = await buyNow({
      productId,
      productVariant: opts,
      qty: 1,
    });

    const checkoutSearchParams = new URLSearchParams();
    checkoutSearchParams.set("timestamp", Date.now().toString());
    checkoutSearchParams.set("selected", selectedItems.join("."));

    push(
      buildUrl("/checkout", checkoutSearchParams),
    );
  };

  return (
    <BuyNowDisplay
      onClick={handleBuyNow}
      disabled={loading || opts === null}
      t={t}
    />
  );
};
